import EcoLink from 'eco-design/base/eco-link';
import EcoImg from 'eco-design/base/eco-img';
import gtm from 'eco-design-reliance/gtm';
import { useRouter } from 'next/router';
import { FormatMoneyLocal } from '@elem/ui-common/utils/FormatMoneyLocal';

import css from './index.module.scss';
import { useLang } from '@/i18n';

export default function ShopifyProductItem({ product, isMobile = false }: any) {
    const { t } = useLang('shared');
    const { locale } = useRouter();

    const imagePath = product?.img || product?.variantImg;

    const handleBuyNowClick = (product: any) => {
        if (typeof window !== 'undefined') {
            const searchEntry: any = localStorage.getItem('search_entry');

            gtm.push({
                event: 'uaEvent',
                event_name: 'buy',
                product_name: product?.productTitle || product?.skuTitle,
                position: 'search_explore_bottom',
                view_page_type: 'shopify PDP',
                navigation_name: 'none',
                source_method: searchEntry || '',
            });
        }
    };

    return (
        <div className={css.aiShopifyProductItem}>
            <EcoLink
                href={product?.handle ? `https://${locale}.ecoflow.com/products/${product?.handle}?variant=${product?.variantId}` : ''}
                onClick={() => handleBuyNowClick(product)}
            >
                <div className="productImg">
                    <EcoImg alt={product?.productTitle || product?.skuTitle} pc={imagePath} h5={imagePath} />
                </div>
                <div className="productInfo">
                    {product?.label && <p className="productLabel">{product?.label}</p>}
                    <h3 className="productTitle">{product?.productTitle || product?.skuTitle}</h3>
                    {product?.variantDescription && <p className="productDescription">{product?.variantDescription}</p>}

                    <div className="productPriceBox">
                        <p className="productPrice">{FormatMoneyLocal(product?.price, locale)}</p>
                        {product?.compareAtPrice && product?.compareAtPrice !== product?.price && (
                            <p className="productComparePrice">{FormatMoneyLocal(product?.compareAtPrice, locale)}</p>
                        )}
                    </div>
                    {product?.handle && (
                        <div className="productItemLinks">
                            <EcoLink href={`https://${locale}.ecoflow.com/products/${product?.handle}?variant=${product?.variantId}`}>
                                <span className="font-family-medium link">{t('support.site_support_learn_more')}</span>
                            </EcoLink>
                        </div>
                    )}
                </div>
            </EcoLink>
        </div>
    );
}
